import React from 'react';
import jQuery from 'jquery';
import Configurator from './Configurator.jsx';
import IekArticleList from './ui/IekArticleList.jsx';
import styles from './Vr32iConfigurator.styl';
import Image from './ui/Image.jsx';
import Button from './ui/button/Button.jsx';


/**
 * Конфигуратор Выключателя-разъединителя типа ВР32И
 * @see http://helpdesk.iek.local/Task/View/258372
 */
class Vr32iConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = jQuery.extend({}, this.state, {
			itemList: [],
			specList: []
		});

		// this.filter.arcing_chambers = 'наличие';

		this.onBtnSpecSaveClick = this.onBtnSpecSaveClick.bind(this);
		this.onSpecListItemDelete = this.onSpecListItemDelete.bind(this);
		this.onSpecListItemNumChange = this.onSpecListItemNumChange.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
	}

	getType() {
		return 'vr32i';
	}

	getCustomStyles() {
		return styles;
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.state.specList)
		};

		super.doPrint(_params);
	}

	onAfterDbLoad() {
		this.setState({
			itemList: this.db.list
		});
	}

	onBtnSpecSaveClick() {
		if (!this.state.item) {
			return;
		}

		this.setState(prevState => {

			let specList = JSON.parse(JSON.stringify(prevState.specList));

			// Если уже есть такой, увеличиваем кол-во
			for (let i = 0; i < specList.length; i++)
			{
				if (specList[i].item.article === prevState.item.article)
				{
					specList[i].count++;

					return {
						specList
					};
				}
			}

			const specListItem = {
				item: prevState.item,
				count: 1,
				name: prevState.item.name,
				article: prevState.item.article
			};

			specList.push(specListItem);

			return {
				specList
			};
		},()=>{
			this.doAddToCart(this.state.specList)});
	}

	onSpecListItemDelete(deleteEvent) {
		this.setState(prevState => {

			let specList = prevState.specList.filter(specListItem => {
				return (specListItem.item.article !== deleteEvent.item.article);
			});

			if (specList.length === prevState.specList.length)
			{
				specList = prevState.specList.filter(specListItem => {
					return (specListItem.pickedUpItem.article !== deleteEvent.item.article);
				});
			}

			return {specList};

		},()=>{
			this.doAddToCart(this.state.specList)});
	}

	onSpecListItemNumChange(numChangeEvent) {
		this.setState(prevState => {

			const specList = prevState.specList.slice();

			specList.forEach(specListItem => {

				if (specListItem.item.article === numChangeEvent.item.article)
				{
					specListItem.count = numChangeEvent.value;
				}

			});

			return {
				specList
			};

		},()=>{
			this.doAddToCart(this.state.specList)});
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	render() {
		if (!this.db) {
			return <div className={styles.cfg} />;
		}

		const itemList = this.state.itemList.filter(item => this.state.articles.indexOf(item.article) !== -1);

		const specList = this.state.specList.map(specListItem => ({
			article: specListItem.item.article,
			name: specListItem.count
		}));

		return (
			<div className={styles.cfg}>
				<div className={styles.title}>Конфигуратор подбора выключателя-разъединителя ВР32И</div>

				{/* Подобрать аксессуар к Кабель-каналу */}
				<label className={styles.modeCableChk}><input type="checkbox"
					checked={this.filter.arcing_chambers ? this.filter.arcing_chambers === 'наличие' : false}
					onChange={e => this.onFilterChange('arcing_chambers', e.target.checked ? 'наличие' : 'Все')} /></label>

				{/* Подобрать аксессуар к Трубе */}
				<label className={styles.modePipeChk}><input type="checkbox"
					checked={this.filter.aux_contacts ? this.filter.aux_contacts === 'наличие' : false}
					onChange={e => this.onFilterChange('aux_contacts', e.target.checked ? 'наличие' : 'Все')} /></label>

				{this.buildDropdownFilters({
					skip: ['arcing_chambers', 'aux_contacts'],
					filterLabels: this.db.filter_names
				})}

				{/* Список */}
				<IekArticleList
					items={itemList}
					wrapStyle={styles.articleListPipe_wrapStyle}
					tableWrapStyle={styles.articleListPipe_tableWrap}
					articleCellStyle={styles.articleList_articleCell}
					selectedItem={this.state.item}
					onSelect={item => this.onListItemCheck(item.article)}
				/>

				{/* Артикул и имя */}
				{this.state.item ? (
					<div className={styles.itemInfo}>
						<a href={`/products/catalog/?page=detail&article=${this.state.item.article}`} target="_blank"
							 rel="noopener noreferrer" className={styles.itemInfo_Article}>{this.state.item.article}</a>
						<div>{this.state.item.name}</div>
					</div>
				) : (
					<div className={styles.itemInfoNoArticle} />
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
				/>

				{/* Описание */}
				{this.state.item && this.state.item.description &&
					<div className={styles.description}>
						{this.state.item.description}
					</div>
				}

				{/* Спецификация оборудования */}
				<IekArticleList
					items={specList}
					wrapStyle={styles.specList_wrapStyle}
					tableWrapStyle={styles.specList_tableWrap}
					articleCellStyle={styles.specList_articleCell}
					cellStyle={styles.specList_countCell}
					deleteStyle={styles.specListDelete}
					selectedItem={this.state.item}
					nameType="num"
					onSelect={item => this.onListItemCheck(item.article)}
					onDelete={this.onSpecListItemDelete}
					onNumChange={this.onSpecListItemNumChange}
				/>
				<Button
					x="360"
					y="615"
					buttonStyle={styles.mainBtn}
					buttonDisabledStyle={styles.mainBtnDisabled}
					textStyle={styles.mainBtnText}
					iconStyle={styles.pickUpBtnIcon}
					text="В корзину"
					disabled={!this.state.specList.length}
					onClick={() => this.doAddToCart(this.state.specList.map(i => ({
						count: i.count, name: i.item.name,
						article: i.item.article})
					))}
				/>
				{/* Сохранить в спецификацию */}
				<div className={styles.btnSpecSave} onClick={this.onBtnSpecSaveClick} />

				{/* Распечатать */}
				<div className={styles.btnPrint} onClick={this.onBtnPrintClick} />

				{/* Сохранить в PDF */}
				<div className={styles.btnPdf} onClick={this.onBtnPrintPdfClick} />

				{/* Сохранить в Excel */}
				<div className={styles.btnExcel} onClick={this.onBtnExcelClick} />

				{/* Скачать базу Revit */}
				<a className={styles.btnRevit} href="/products/standard_solutions/download/02-silovoe-oborudovanie-zashchity-i-kommutacii-iek.rar" />

				{/* На основной сайт IEK */}

				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '722px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '22px',
					top: '722px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '725px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		);
	}
}

export default Vr32iConfigurator;



// WEBPACK FOOTER //
// ./src/react/Vr32iConfigurator.jsx